import { useEffect, useRef } from "react";

export function useRefetchOnFocus(callback) {
  const callbackRef = useRef(callback);
  const lastCallTimeRef = useRef(0);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handleRefetch = () => {
      if (document.visibilityState !== "visible") return;

      const now = Date.now();

      if (now - lastCallTimeRef.current < 200) return;

      lastCallTimeRef.current = now;
      callbackRef.current?.();
    };

    window.addEventListener("focus", handleRefetch);
    document.addEventListener("visibilitychange", handleRefetch);

    return () => {
      window.removeEventListener("focus", handleRefetch);
      document.removeEventListener("visibilitychange", handleRefetch);
    };
  }, []);
}
